// Chicken egg-laying (MB.3). PURE (ENG-1). An adult chicken lays an egg every
// 6000–12000 ticks (Java's 5–10 min timer). The host tracks each chicken's timer
// and drops the egg; this owns the delay maths.

export const EGG_MIN_TICKS = 6000;
export const EGG_MAX_TICKS = 12000;

/** A seeded next-egg delay in the 5–10 minute window. */
export function nextEggDelay(roll: number): number {
  const span = EGG_MAX_TICKS - EGG_MIN_TICKS;
  return EGG_MIN_TICKS + Math.floor(Math.max(0, Math.min(1, roll)) * span);
}

/** The delay a particular hen waits (§28.6): `round(nextEggDelay(roll) · eggMul)`. The
 *  egg_rate gene's range is inverted, so a high gene means a SHORTER wait; with the rule
 *  off `eggMul` is exactly 1 and this is `nextEggDelay(roll)` to the tick. */
export function eggDelay(roll: number, eggMul: number): number {
  return Math.round(nextEggDelay(roll) * eggMul);
}
